import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { ProjectFilterKeys } from '../../../../shared/organizationPackages';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import FilterCardCheckboxes from '../../generic/Filter/FilterCardCheckboxes';
import type { AnyFilter, BlockType } from '../../../../shared/organizationPackages';
import type { SelectOption } from '../../../types';

const BLOCK_TYPE_OPTIONS: SelectOption[] = [
  { value: 'has_blocked_packages', label: 'Uses blocked package(s)' },
  { value: 'no_blocked_packages', label: 'No blocked package(s)' },
];

type Props = {
  setFilters: (filter: AnyFilter) => void;
};

/**
 * PackageBlockType displays two checkboxes to let users filter by block type (blocked packages or non-blocked packages).
 */
const PackageBlockType: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const blockTypes = useSelector(PackageInventoryStore.selectors.getBlockTypeFilters);

  // map current blockTypes to SelectOption format
  const selectedCheckboxes = blockTypes.map((blockType: string) => ({
    label: BLOCK_TYPE_OPTIONS.find(option => option.value === blockType)?.label || blockType,
    value: blockType,
  }));

  // handle onChange from FilterCardCheckboxes
  const onChange = (newSelected: SelectOption[]) => {
    const selectedTypes = newSelected.map(({ value }) => value as BlockType);
    setFilters({ [ProjectFilterKeys.BlockTypes]: selectedTypes });
  };

  return (
    <FilterCardCheckboxes
      label="Blocked"
      options={BLOCK_TYPE_OPTIONS}
      values={selectedCheckboxes}
      onChange={onChange}
      testId="package-inventory-filters--block-type"
    />
  );
};

export default PackageBlockType;
